import { useAuth } from '../../../context/AuthContext'

export default function NavbarTablet() {
  const { session } = useAuth()

  return (
    <div>
      <h5>{session?.user?.user_metadata?.full_name || 'Usuario'}</h5>
    </div>
  )
}
